import React, { Component } from 'react'
import _ from 'lodash'

export default class ShowData extends Component {
  constructor(props) {

    var databases = [
      'credentials',
      'logged_in_user',
      'labels',
      'users',
      'messages',
      'events',
      'sessions',
      'sponsors',
      'leaderboard',
      'homepage'
    ]
    super(props)
    this.state = {
      databases: databases
    }
  }

  render() {
    const dbs = []
    _.each(this.state.databases, function(database){
      dbs.push(<div key={database} ><h1>{database}</h1><pre className="debug-json">{JSON.stringify(JSON.parse(localStorage.getItem(database)), false, 2)}</pre></div>)
    })
    return (
      <div>
        <p>DataStores:</p>
        {dbs}
      </div>
    )
  }
}
